import { Injectable } from "@angular/core";
import { HttpclientService, LocalstorageService, UserService } from "../../shared";
import { BehaviorSubject, Subject } from "rxjs";
import { Observable } from "rxjs";

@Injectable()
export class PersonSelectorService {
	constructor(private httpclientService: HttpclientService, private userService: UserService, private localService: LocalstorageService) {}

	private AudienceIdChangedSubject = new Subject<any>();
	private SelectedPersonSubject = new Subject<any>();
	private SelectedMuliplePersonIdSubject = new Subject<any>();
	private SelectedSchoolSubject = new Subject<any>();
	private PhotoIsClicked = new Subject<any>();
	private sUnselectItemsSubject = new Subject<any>();

	private RefreshPersonInfo = new Subject<any>();

	//Refresh new
	private ThumbnailRefreshSubject = new BehaviorSubject("");
	ThumbnailRefreshObservable = this.ThumbnailRefreshSubject.asObservable();

	private TableRefreshSubject = new BehaviorSubject("");
	TableRefreshObservable = this.TableRefreshSubject.asObservable();

	//-----------------------------------------------------------------------------------------------------
	//
	//	Wire Up ThumbnailRefresh Events (IN)
	//
	//-----------------------------------------------------------------------------------------------------
	ThumbnailRefresh(data: any) {
		this.ThumbnailRefreshSubject.next(data);
	}

	TableRefresh(data: any) {
		this.TableRefreshSubject.next(data);
	}

	UnselectItems() {
		this.sUnselectItemsSubject.next(null);
	}

	onUnselectItems(): Observable<any> {
		return this.sUnselectItemsSubject.asObservable();
	}

	loadDynamicGroup(audienceID) {
		var postResult$ = new Subject();
		var url = "PersonSelector/DynamicGroupGetList?audienceID=" + audienceID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadDynamicGroupValue(schoolID, dynamicGroupID) {
		var postResult$ = new Subject();
		var url = "PersonSelector/DynamicGroupValueGetList?schoolID=" + schoolID + "&dynamicGroupID=" + dynamicGroupID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadTablePerson(params) {
		var postResult$ = new Subject();
		var url = "PersonSelector/PersonGetTableList";

		var promise$ = this.httpclientService.post(url, params);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadPerson(params) {
		var postResult$ = new Subject();
		var url = "PersonSelector/PersonGetList";

		var promise$ = this.httpclientService.post(url, params);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
	onPersonGetChange(): Observable<any> {
		return this.SelectedPersonSubject.asObservable();
	}

	onSelectedMultiplePersons(): Observable<any> {
		return this.SelectedMuliplePersonIdSubject.asObservable();
	}

	onAudienceIdChange(): Observable<any> {
		return this.AudienceIdChangedSubject.asObservable();
	}

	onSchoolSelectedChange(): Observable<any> {
		return this.SelectedSchoolSubject.asObservable();
	}

	onRefreshPersonInfo(): Observable<any> {
		return this.RefreshPersonInfo.asObservable();
	}

	onPhotoClicked(): Observable<any> {
		return this.PhotoIsClicked.asObservable();
	}

	personGet(personID) {
		var postResult$ = new Subject();
		var url = "PersonSelector/PersonGet?personID=" + personID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
			this.SelectedPersonSubject.next(response);
		});
		return postResult$;
	}

	ProcessSelectMultiplePersonId(lstPersonID) {
		/* 
    const lstPersonID=[]
    $.each(lstSelected, function (index, result) {
      var id = result.split('|');
      var PersonID = id[0];
      lstPersonID.push(PersonID)
    });
    */
		this.SelectedMuliplePersonIdSubject.next(lstPersonID);
	}

	changeAudienceId(AudienceId) {
		this.AudienceIdChangedSubject.next(AudienceId);
	}

	setSchool(school) {
		this.SelectedSchoolSubject.next(school);
	}

	setPhotoClicked(personID) {
		this.PhotoIsClicked.next(personID);
	}
	refreshPerson(personID) {
		this.RefreshPersonInfo.next(personID);
	}

	personPhotoGet(personID) {
		var postResult$ = new Subject();

		//
		// Images don't refresh if you pass a link to a controller that needs
		// to be evaluated. Instead you need to set an img's src to a base64 string
		// (the raw data)
		//
		var url = "PersonPhoto/ThumbnailGet?PersonID=" + personID;
		// var url='PersonPhoto/ThumbnailGetOld?PersonID='+personID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	private subjectFilterChanged = new Subject<any>();
	filterChanged(params) {
		this.subjectFilterChanged.next(params);
	}

	onFilterChange(): Observable<any> {
		return this.subjectFilterChanged.asObservable();
	}

	private subjectChanged = new Subject<any>();
	personSelectedChanged(person) {
		this.subjectChanged.next(person);
	}

	onPersonSelectChange(): Observable<any> {
		return this.subjectChanged.asObservable();
	}

	////////////////////////////////////////////////////////////
	// For Student Scan History
	////////////////////////////////////////////////////////////
	private tableChangedSubject = new Subject<any>();
	tableChanged(lstPerson) {
		this.tableChangedSubject.next(lstPerson);
	}
	onTableChange(): Observable<any> {
		return this.tableChangedSubject.asObservable();
	}

	////////////////////////////////////////////////////////////

	RefreshPhotoGet(PersonID) {
		var postResult$ = new Subject();
		var url = "PersonSelector/RefreshPhotoGet?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GetSBMPreference() {
		var postResult$ = new Subject();
		var url = "SysAdmin/GetSBMPreference?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PersonSelectorRoleGetList() {
		var postResult$ = new Subject();
		var url = "PersonSelector/PersonSelectorRoleGetList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ManuallyChangeSchool(School) {
		var user: any;
		user = this.userService.getCurrentUser();

		//
		// Load Student Filter
		//
		try {
			var StudentFilter: any = this.localService.getItem("personselector_" + user.userID + "_" + 1);

			if (StudentFilter != undefined) {
				StudentFilter.SchoolID = School.SchoolID;
				StudentFilter.dynamicGroupID = 1;
				StudentFilter.dynamicGroupName = "School";
				StudentFilter.dynamicGroupValueID = School.SchoolID;

				this.localService.setItem("personselector_" + user.userID + "_" + 1, StudentFilter);
			}
		} catch (e) {
			e.toString();
		}

		//
		// Load Staff Filter
		//
		try {
			var StaffFilter: any = this.localService.getItem("personselector_" + user.userID + "_" + 2);

			if (StaffFilter != undefined) {
				StaffFilter.SchoolID = School.SchoolID;
				StaffFilter.dynamicGroupID = 1;
				StaffFilter.dynamicGroupName = "School";
				StaffFilter.dynamicGroupValueID = School.SchoolID;

				this.localService.setItem("personselector_" + user.userID + "_" + 2, StaffFilter);
			}
		} catch (e) {
			e.toString();
		}

		this.setSchool(School);
	}
}
